import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "bootstrap/dist/css/bootstrap.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MyThemeProvider } from "./ThemeContext";
import AppProvider from "./provider/AppContext";
import { store } from "./redux/store/index";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { message } from "antd";

// Defer ResizeObserver callbacks by a frame. CKEditor's grouped toolbar
// (#283) re-measures on resize and otherwise trips the benign
// "ResizeObserver loop completed with undelivered notifications" warning,
// which CRA's dev overlay surfaces as an error. Deferring to the next frame
// breaks the synchronous loop so it never fires — no behaviour change.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// Last-resort safety net: an API rejection that slips past a local try/catch
// must degrade to an error toast, never take down the page (the dev overlay /
// a blank screen). The axios interceptor rejects with {data, status,
// statusText}, so pull the server message when one exists. Handlers should
// still catch locally — this only stops the worst case.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const serverMessage =
    typeof reason?.data?.message === "string" ? reason.data.message : null;
  console.error("Unhandled promise rejection", reason);
  message.error(serverMessage || "Something went wrong. Please try again.");
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const WrappedApp = () => (
  <React.Fragment>
    <Provider store={store}>
      <AppProvider>
        <MyThemeProvider>
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}
          >
            <App />
          </GoogleOAuthProvider>
        </MyThemeProvider>
      </AppProvider>
    </Provider>
  </React.Fragment>
);

root.render(<WrappedApp />);
reportWebVitals();
